import React, { useState } from 'react'
import { Modal, Button, Form, Input, DatePicker, Select, Row, Col, message } from '@pankod/refine-antd'
import { useUserContext } from 'context/user'
import { uploadedQuestionForReview } from 'helpers/question/uploadedQuetionForReviewProcess'
const { Option } = Select

interface Props {
  selectedRowKeys: any[]
  userId: string
  reloadPage: () => Promise<void>
}
const ReviewModal: React.FC<Props> = ({ selectedRowKeys, userId, reloadPage }) => {
  const [visible, setVisible] = useState(false)
  const [loading,setLoading]=useState<boolean>(false)
  const [form] = Form.useForm()
  const { qapproverList, qcreatorList, qreviewerList } = useUserContext()

  //questions review process
  const handleQuestionReview = async (values: any) => {
    setLoading(true)
    const forReviewProcess = await uploadedQuestionForReview({ ...values, user_id: userId }, selectedRowKeys)
    if (forReviewProcess) {
      message.success('Selected questions have been forwarded for review.')
      form.resetFields() 
      await reloadPage()
      setVisible(false)
    }else{
      message.error('Unable to complete the process')
    }
    setLoading(false)
  }
  return (
    <>
      <Button
        onClick={() => setVisible(true)}
        style={{
          marginBottom: '5px',
          backgroundColor: '#6659FF',
          color: '#fff',
          border: '1px solid #6659FF',
          borderRadius: '6px',
        }}
      >
        Send for Review
      </Button>

      <Modal
        visible={visible}
        title="Review Modal"
        width={'90%'}
        onOk={() => {
          form.submit()
        }}
        confirmLoading={loading}
        onCancel={() => setVisible(false)}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={async values => {
            console.log(values, 'Values are this')
            await handleQuestionReview(values)
          }}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Please enter a name' }]}>
                <Input placeholder="Enter name" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item label="Expected Date" name="expectedDate" rules={[{ required: true, message: 'Please select a date' }]}>
                <DatePicker
                  style={{ width: '100%' }}
                  disabledDate={current => current && current.isBefore(new Date().setDate(new Date().getDate() + 1))}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={8}>
              <Form.Item label="Creator" name="creator" rules={[{ required: true, message: 'Please select a creator' }]}>
                <Select placeholder="Select creator">
                  {qcreatorList.length > 0 &&
                    qcreatorList?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.displayName}
                      </option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={8}>
              <Form.Item label="Reviewer" name="reviewer" rules={[{ required: true, message: 'Please select a reviewer' }]}>
                <Select placeholder="Select reviewer">
                  {qreviewerList.length > 0 &&
                    qreviewerList?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.displayName}
                      </option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={8}>
              <Form.Item label="Approver" name="approver" rules={[{ required: true, message: 'Please select an approver' }]}>
                <Select placeholder="Select approver">
                  {qapproverList.length > 0 &&
                    qapproverList?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.displayName}
                      </option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  )
}

export default ReviewModal
